import React from 'react';

import { TransactionsContainer } from 'containers';

export const TransactionsPage = () => (
  <div>
    <TransactionsContainer />
  </div>
);
